import styled from 'styled-components';
import { IThemeProvider } from '../../../../styles/theme';

export const Form = styled.form`
  ${({ theme }: IThemeProvider) => `
    margin-top: ${theme.layout.spacing.centy};
  `};

  [data-testid='input-label'] {
    ${({ theme }: IThemeProvider) => `
      color: ${theme.colors.primary[100]};
    `}
  }
`;

export const SubmitButtonCont = styled.div`
  ${({ theme }: IThemeProvider) => `
      margin-bottom: ${theme.layout.spacing.deka};
  `};
`;

export const LowercaseHeadline = styled.span`
  text-transform: lowercase;
`;
